import { ReactNode, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import EdgeTrigger from './EdgeTrigger'
import HoverDrawer from './HoverDrawer'
import LeftSidebarContent from './LeftSidebarContent'
import RightSidebarContent from './RightSidebarContent'

interface GlobalHoverSidebarProps {
  children: ReactNode
}

const CLOSE_COOLDOWN_MS = 400

const GlobalHoverSidebar = ({ children }: GlobalHoverSidebarProps) => {
  const location = useLocation()
  const [leftOpen, setLeftOpen] = useState(false)
  const [rightOpen, setRightOpen] = useState(false)
  const leftClosedAt = useRef(0)
  const rightClosedAt = useRef(0)

  const isDashboard =
    location.pathname === '/dashboard' || location.pathname === '/'
  const shouldShowSidebar = isDashboard

  const handleLeftOpen = () => {
    if (Date.now() - leftClosedAt.current > CLOSE_COOLDOWN_MS) {
      setLeftOpen(true)
    }
  }
  const handleLeftClose = () => {
    if (!!document.querySelector("#SelectLabelDashboard-GlobalHoverSidebar")) return;
    setLeftOpen(false)
    leftClosedAt.current = Date.now()
  }
  const handleRightOpen = () => {
    if (Date.now() - rightClosedAt.current > CLOSE_COOLDOWN_MS) {
      setRightOpen(true)
    }
  }
  const handleRightClose = () => {
    if (!!document.querySelector("#SelectLabelDashboard-GlobalHoverSidebar")) return;
    setRightOpen(false)
    rightClosedAt.current = Date.now()
  }

  return (
    <>
      {shouldShowSidebar && (
        <>
          <EdgeTrigger
            position="left"
            onMouseEnter={handleLeftOpen}
            isHidden={leftOpen}
          />

          <HoverDrawer
            isOpen={leftOpen}
            position="left"
            onMouseLeave={handleLeftClose}
          >
            <LeftSidebarContent onClose={handleLeftClose} />
          </HoverDrawer>

          <EdgeTrigger
            position="right"
            onMouseEnter={handleRightOpen}
            isHidden={rightOpen}
          />

          <HoverDrawer
            isOpen={rightOpen}
            position="right"
            onMouseLeave={handleRightClose}
          >
            <RightSidebarContent onClose={handleRightClose} />
          </HoverDrawer>
        </>
      )}

      {children}
    </>
  )
}

export default GlobalHoverSidebar
